/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Monthly_Metrics_Max_ValueInputs */

const es_billing_monthly_metrics_max_value = /** @type {(inputs: Billing_Monthly_Metrics_Max_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo mensual`)
};

const en_billing_monthly_metrics_max_value = /** @type {(inputs: Billing_Monthly_Metrics_Max_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly peak`)
};

/**
* | output |
* | --- |
* | "Monthly peak" |
*
* @param {Billing_Monthly_Metrics_Max_ValueInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_monthly_metrics_max_value = /** @type {((inputs?: Billing_Monthly_Metrics_Max_ValueInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Monthly_Metrics_Max_ValueInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_monthly_metrics_max_value(inputs)
	return en_billing_monthly_metrics_max_value(inputs)
});
export { billing_monthly_metrics_max_value as "billing.monthly.metrics.max_value" }